/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserPreferenceListResponse {
    getFixupPrototypeFunction() { return UserPreferenceListResponse.fixupPrototype; }

    static newInstance(model: Partial<UserPreferenceListResponse>): UserPreferenceListResponse {
        let obj = Object.assign(new UserPreferenceListResponse(), model);
        UserPreferenceListResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserPreferenceListResponse>): UserPreferenceListResponse {
        if (!model) return null;
        return UserPreferenceListResponse.newInstance(<UserPreferenceListResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserPreferenceListResponse) {
        if (!obj) return;

        models.UserPreferenceListResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserPreferenceListResponse): boolean {
        Object.setPrototypeOf(obj, UserPreferenceListResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.names) {
            for (let key in this.names) {
                let val = this.names[key];
                if (typeof val === "string") {
                    this.names[key] = new Date(<string><any>val);
                }
            }
        }
    }

    /**
     * Map from name to last update timestamp
     */
    names: { [key: string]: Date; };

}
